import { Heading } from '@/hen-ui/atomics/Heading';
import { Text } from '@/hen-ui/atomics/Text';
import { Flex } from '@/hen-ui/composites/Flex';

import type { CareerExplorerStatistic } from './types';

export const CareerExplorerStatisticCard = ({
  caption,
  title,
  value,
}: CareerExplorerStatistic) => (
  <Flex
    gap='xs'
    className='rounded-md border border-neutral-200 bg-white p-sm md:gap-sm lg:rounded-sm'
  >
    <Heading
      tag='h4'
      variant='h4'
      color='secondary'
      className='font-normal lg:text-h5 lg:leading-h5'
    >
      {title}
    </Heading>
    <Heading tag='p' variant='h2' color='secondary' className='font-normal'>
      {value}
    </Heading>
    <Text
      variant='b4'
      color='secondary'
      className='font-normal lg:text-b5 lg:leading-b5'
    >
      {caption}
    </Text>
  </Flex>
);
